import script from "./RegionEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionEdit.vue?vue&type=script&setup=true&lang=js"

import "./RegionEdit.vue?vue&type=style&index=0&id=70c97b57&lang=less"

const __exports__ = script;

export default __exports__